// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ba3a0083","389":"d3e67c9a","732":"9cc3ce7d","857":"280c9a7e","977":"6709f33f"}[chunkId] + ".chunk.js";
};